









import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";

@Component
export default class ImportUser extends AbpBase {
  baseUrl = XMLHTTP_BASEURL;
  file: any = {};
  headers = {
    Authorization: `Bearer ${window.abp.auth.getToken()}`,
    "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
  };

  async handleUploadSuccess(res: any, file: any) {
    if (res.result && res.result.data) {
      // 执行导入数据的操作
      await this.$store.dispatch({
        type: "user/importUsersFromExcel",
        data: {
          filePath: res.result.data,
          communityId: this.$store.state.session.user.communityId
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/user/import.vue